// extracted by mini-css-extract-plugin
export const mainSection = "privacy-module--mainSection--bJADp";
export const contentWrap = "privacy-module--contentWrap--Uzx4U";
export const content = "privacy-module--content--1El4o";
export const wrapper = "privacy-module--wrapper--32Rvc";
export const componentWrapper = "privacy-module--componentWrapper--3PC3s";